import React, { useEffect, useState } from "react";
import MaterialTable from "@material-table/core";
import { TylerEnvelopeService } from "../../../../../services/SubmissionService";
import * as APIModels from "../../../../../models";
import { Button } from "react-bootstrap";

export default function CaseSearchResults(params: {
    cases: APIModels.CourtCase[];
}): JSX.Element {
    const [displays, setDisplays] = useState<APIModels.CourtCase[]>(
        params.cases
    );
    const [caseData, setCaseData] = useState<APIModels.CaseData>(
        {} as APIModels.CaseData
    );

    useEffect(() => {
        setDisplays([...params.cases]);
    }, [params.cases]);

    const onTylerEFile = (url: string, courtCase: APIModels.CaseData) => {
        console.log("Beging Efile " + url);
        TylerEnvelopeService.fileIntoExisting({ body: courtCase }).then(
            (resp) => {
                console.log("RESPONSE " + JSON.stringify(resp));
                if (resp.successful === true && resp.data) {
                    window.location.href = url + "/" + resp.data.id;
                }
            },
            (error) => {
                console.log("RESPONSE ");
            }
        );
    };

    return (
        <div>
            <MaterialTable
                columns={[
                    {
                        title: "Case Number",
                        field: "caseNumber",
                    },
                    {
                        title: "Case Name",
                        field: "caseTitle",
                    },
                    {
                        title: "Get Information",
                        field: "",
                        render: (row) => {
                            return (
                                <Button
                                    size="lg"
                                    onClick={() => {
                                        onTylerEFile("/tyler/existing", {
                                            ucn: row.ucn!,
                                            countyID: row.countyID!,
                                            caseTitle: row.caseTitle!,
                                            divisionID: row.divisionID!,
                                            caseTypeID: row.caseTypeID!,
                                            courtCaseNumber: row.caseNumber!,
                                        } as APIModels.CaseData);
                                    }}
                                >
                                    <i className="ri-search-eye-line"></i>
                                </Button>
                            );
                        },
                    },
                ]}
                data={displays}
                title="Case Search Results"
                options={{
                    actionsColumnIndex: -1,
                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                }}
            />
            {/*** XXX(Brett): DO NOT HAVE THIS IN THE PROD BUILD
                              THIS IS A CONVIENIENCE*/}
            <div className="row">
                <h3 style={{ color: "red" }}>
                    DO NOT HAVE THIS IN THE PROD BUILD
                </h3>
                <div className="col-6">
                    <div
                        style={{ maxWidth: "100%" }}
                        onClick={() => {
                            onTylerEFile("/tyler/existing", {
                                ucn: "f4ef6e71-179d-4af8-b16d-a4922d3298aa",
                                countyID:
                                    "d05fc113-f383-49b5-8771-a27ccc8e97c2",
                                caseTitle:
                                    "IN THE MATTER OF THE MARRIAGE OF VERONICA SANTANA VS. EDWARD RODRIGUEZ, Jr. AND IN THE INTEREST OF M. R. CHILD(REN)",
                                divisionID:
                                    "b40d7177-a881-48c8-8e53-11f8a0441f68",
                                caseTypeID:
                                    "ea3f5090-e1bc-42b9-82d4-80050cf36578",
                                courtCaseNumber: "D-1-FM-18-001453",
                            });
                        }}
                    >
                        <button>White Rat Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
